<!-- @format -->
<bank-form-tag>

    <table class="detail_table">
        <tr class="detail_table-row">
            <th class="information_table-heading">
                銀行・支店情報
            </th>
            <td class="information_table-data">

                <p class="note">
                    銀行情報のご入力につきましては、以下のボタンをクリックすると表示されるメニューをご利用ください
                </p>

                <div class="box_flex01" style="margin-bottom: 2rem">
                    <div class="box_w20 margin-spacing-1_top">
                        <div class="button button-secondary-mini" type="button" onclick="{e=>openSearchModal(e)}">
                            銀行・支店検索
                        </div>
                    </div>

                </div>

                <div class="box_flex02">

                    <div class="box_w40">
                        <label class="form-heading" for="bank_name">銀行名</label>
                        <input
                                class="text_input"
                                type="text"
                                name="bank_name"
                                id="bank_name"
                                is="binding-tag"
                                readonly
                        />
                        <input type="hidden" name="bank_code">
                    </div>
                </div>
                <div class="box_flex05 margin-spacing-3_top">
                    <div class="box_w40 margin-spacing-2_right">
                        <label class="form-heading" for="branch_name">支店名</label>
                        <input
                                class="text_input"
                                type="text"
                                name="branch_name"
                                id="branch_name"
                                is="binding-tag"
                                readonly
                        />
                        <input type="hidden" name="branch_code">
                    </div>
                </div>
            </td>
        </tr>
        <tr class="detail_table-row">
            <th class="information_table-heading">預金種別</th>
            <td class="information_table-data">
                <div class="box_flex01">
                    <div class="box_w40">
                        <input
                                class="radio_input"
                                type="radio"
                                name="account_type"
                                id="account_type"
                                value="normal"
                                checked="{ bankAccount.item.account_type==='normal' }"
                                onclick="{ onChangeType }"
                        />
                        <label class="radio_label" for="account_type">普通</label>
                    </div>
                </div>
                <p class="note margin-spacing-1_top">※当座、貯蓄口座でのご利用はできません。</p>
            </td>
        </tr>
        <tr class="detail_table-row">
            <th class="information_table-heading">口座番号</th>
            <td class="information_table-data">
                <div class="box_w40">
                    <input
                            class="text_input"
                            type="text"
                            name="account_number"
                            is="binding-tag"
                            errmsg="半角数字で入力してください"
                    >
                </div>
                <p class="note margin-spacing-1_top">※7桁より少ない場合は、左側を0で埋めてください。</p>
            </td>
        </tr>
        <tr class="detail_table-row">
            <th class="information_table-heading">口座名義<br>（カタカナ）</th>
            <td class="information_table-data">
                <div class="box_w40">
                    <input
                            class="text_input"
                            type="text"
                            name="account_name"
                            is="binding-tag"
                            errmsg="カタカナで入力してください"
                    >
                </div>
                <p class="note margin-spacing-1_top">※「カタカナ」でご入力ください。</p>
            </td>
        </tr>
    </table>

    <div class="wrap_button margin-spacing-3_top">
        <div
                class="button button-primary"
                onclick="{ submit }"
                type="button"
                value="銀行口座情報を変更する"
                data-target=""
        ><span class="icon_documents"></span>口座情報を登録・変更する
        </div>
    </div>

    <search-bank-modal-tag api={api} isOpen="{searchModalIsOpen}" onClose={closeSearchModal}></search-bank-modal-tag>

    <script>
        import di from "dependeny-injection";
        import bankAccount from "@model/bankAccount/api";
        import searchBankModal from "@tags/modal/info/search-bank-modal.riot";
        import bindingTag from "@tags/parts/info/bank-account/binding.riot";

        export default {
            components: {
                'binding-tag': bindingTag,
                'search-bank-modal-tag': searchBankModal,
            },
            bankAccount: bankAccount,
            searchModalIsOpen: false,
            onChangeType(e) {
                if (e.target.checked) {
                    this.bankAccount.item.account_type = e.target.value;
                }
            },
            closeSearchModal(e, bank, branch) {
                this.searchModalIsOpen = false
                if (bank && branch) {
                    this.bankAccount.item.bank_name = bank.bank_name_kanji;
                    this.bankAccount.item.bank_code = bank.bank_code;
                    this.bankAccount.item.branch_name = branch.branch_name_kanji;
                    this.bankAccount.item.branch_code = branch.branch_code;
                }
                this.update();
            },
            openSearchModal(e) {
                this.searchModalIsOpen = true
                this.update()
            },
            onBeforeMount() {
                this.api = di.createApi('info');
                this.bankAccount.trigger('fetch')
            },
            submit(e) {
                e.preventDefault()
                this.bankAccount.trigger('save')
            },
            onUpdated() {
                if (this.bankAccount.item.status === 1) {
                    di.router.push("/info/bank-account-confirm")
                }
            }
        }
    </script>
</bank-form-tag>